<template>
    <div>
        <div
            class="mb-7 flex flex-col items-start gap-4 px-0 md:flex-row md:items-start md:justify-between md:gap-6"
        >
            <h2 class="m-0 max-w-3xl text-left font-roboto text-display-sm font-bold tracking-[-0.5px] text-black">
                How Can You Benefit from Our Product Testing Platform
            </h2>

            <UButton
                to="/contact?talk-to-an-expert=true"
                color="primary"
                variant="outline"
                size="lg"
                class="shrink-0"
                label="Talk to an expert"
                trailing-icon="i-pkg-navigation-arrow-right"
                loadingAuto
            />
        </div>

        <div class="grid grid-cols-1 gap-5 md:grid-cols-2">
            <SolutionCard
                v-for="(solution, i) in solutions"
                :key="i"
                class="block h-auto font-manrope"
                :solution="solution"
                :is-vertical="isMobile"
                :to="solution.uri"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SolutionCard from '~/components/common/empower/empower-card'
import { useScreen } from '~/composables/useScreen'

interface BenefitSolution {
    image: string
    title: string
    description: string
    uri: string
}

const baseSolutions: BenefitSolution[] = [
    {
        image: 'arts/Pictogram-lg.svg',
        title: 'Get Accurate Data',
        description: 'Find out who your true consumer is and whether they’ll buy your product. Gather valuable insights before you launch. Our company helps you test your product’s idea, positioning, and messaging, analyze price sensitivity, forecast demand, and more.',
        uri: '',
    },
    {
        image: 'arts/Opt-in-lg.svg',
        title: 'Turn Data Into Insights',
        description: 'Go beyond collecting survey responses. Identify patterns in consumer feedback and understand what drives people to buy your product. Find opportunities for improvement and turn research findings into clear insights that support better marketing decisions.',
        uri: '',
    },
    {
        image: 'arts/Pictogram-2.svg',
        title: 'Research at Right Scale',
        description: 'Run consumer research at the scale you need. Test with hundreds or thousands of participants. Peekage helps manage recruitment, product distribution, and feedback collection. This makes larger studies easier to run.',
        uri: '',
    },
    {
        image: 'arts/Data-01.svg',
        title: 'Get Results Faster',
        description: 'Get the results of your consumer research faster, without waiting weeks. Launch studies quickly and collect responses from the right participants at scale. Peekage helps you gather and analyze feedback, so you can get the insights you need to move your product forward.',
        uri: '',
    },
]

const { isMobile } = useScreen()

const solutions = computed(() => [...baseSolutions])
</script>
